import './AvatarPickerWidget.css';

export default function AvatarPickerWidget({ avatars = [], selectedId, onSelect }) {
  return (
    <div className="avatar-picker-widget">
      <div className="apw-header">
        <span className="apw-title">Choose your AI interviewer</span>
        <span className="apw-subtitle">Select an avatar to personalize your interview experience</span>
      </div>
      <div className="apw-grid">
        {avatars.map((av) => (
          <button
            key={av.id}
            className={`apw-card ${selectedId === av.id ? 'selected' : ''}`}
            onClick={() => onSelect(av)}
          >
            <div className="apw-thumb-wrap">
              {av.thumbnailUrl ? (
                <img src={av.thumbnailUrl} alt={av.name} className="apw-thumb" />
              ) : (
                <div className="apw-thumb-placeholder">
                  <svg width="40" height="40" viewBox="0 0 80 80" fill="none">
                    <circle cx="40" cy="30" r="16" stroke="#7b61ff" strokeWidth="2" fill="none" />
                    <path d="M14 68c0-14.36 11.64-26 26-26s26 11.64 26 26" stroke="#7b61ff" strokeWidth="2" fill="none" />
                  </svg>
                </div>
              )}
              {selectedId === av.id && (
                <div className="apw-check">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <circle cx="8" cy="8" r="8" fill="#7b61ff" />
                    <path d="M5 8l2 2 4-4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              )}
            </div>
            <span className="apw-name">{av.name}</span>
          </button>
        ))}
        {avatars.length === 0 && (
          <div className="apw-loading">
            <div className="apw-spinner" />
            <span>Loading avatars…</span>
          </div>
        )}
      </div>
    </div>
  );
}
